module.exports = __webpack_public_path__ + "static/media/paragard-product-img@3x.8084c7a3.png";